export function dataInRequest(params = {}) {
  return {
    type: '@descargaDetalhe/DATA_IN_REQUEST',
    payload: { params },
  };
}

export function findData(id) {
  return {
    type: '@descargaDetalhe/FIND_DATA',
    payload: { id },
  };
}

export function failedRequest() {
  return {
    type: '@descargaDetalhe/FAILED_REQUEST',
  };
}

export function deleteData(id, params) {
  return {
    type: '@descargaDetalhe/DELETE_DATA',
    payload: { id, params },
  };
}

export function updateData(data, params) {
  return {
    type: '@descargaDetalhe/UPDATE_DATA',
    payload: { data, params },
  };
}

export function storeData(data, params) {
  return {
    type: '@descargaDetalhe/STORE_DATA',
    payload: { data, params },
  };
}

export function successInRequest(data, page, pageSize, totalCount, totalPages) {
  return {
    type: '@descargaDetalhe/SUCCESS_IN_REQUEST',
    payload: { data, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(data) {
  return {
    type: '@descargaDetalhe/SUCCESS_REQUEST',
    payload: { data },
  };
}

export function successRemove(params) {
  return {
    type: '@descargaDetalhe/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@descargaDetalhe/RECORD_FILTERING',
    payload: { params },
  };
}
